import networkservice from '../../services/NetworkService';
import { find, sortBy } from 'lodash';

const getInitialState = function () {
  return {
    loaded: false,
    myManagedNetworks: [],
    myNetworks: [],
    discoverNetworks: [],
    currentNetwork: null,
    trendingNetworks: [],
    userData: [],
  };
};

export default {
  namespaced: true,

  state: getInitialState(),

  getters: {
    isCached: function (state) {
      return state.loaded;
    },
    myManagedNetworks: function (state) {
      return state.myManagedNetworks;
    },
    getAllNetworks: function (state) {
      const combinedNetworks = state.myManagedNetworks.concat(state.myNetworks).concat(state.discoverNetworks);
      // sort by name (case-insensitive)
      const sortedNetworks = sortBy(combinedNetworks, [n => n.name ? n.name.toLowerCase() : '']);
      return sortedNetworks;
    },
    getUserData: function (state) {
      return state.userData;
    }
  },

  mutations: {
    loadNetworks: function (state, { myManagedNetworks, myNetworks, discoverNetworks }) {
      state.myManagedNetworks = myManagedNetworks;
      state.myNetworks = myNetworks;
      state.discoverNetworks = discoverNetworks;
      state.loaded = true;
    },
    loadTrendingNetworks: function (state, trendingNetworks) {
      state.trendingNetworks = trendingNetworks;
      state.loaded = true;
    },

    loaded: function (state, loaded) {
      state.loaded = loaded;
    },

    currentNetwork: function (state, currentNetwork) {
      state.currentNetwork = currentNetwork;
    },

    // goes through our cached list of networks and updates the status
    updateLikeForSlug: function (state, { slug, is_liked }) {
      var list = ['myManagedNetworks', 'myNetworks', 'discoverNetworks'];
      for (let l of list) {
        var found = find(state[l], { slug });
        if (found) {
          found.is_liked = is_liked;
          break;
        }
      }
    },

    setUserData: function (state, userData) {
      state.userData = userData;
    },

    RESET_STATE: function (state) {
      Object.assign(state, getInitialState());
    },
  },

  actions: {
    loadNetworks: function ({ commit }, payload) {
      var search;
      if (payload && 'search' in payload) {
        search = payload.search;
      }

      return networkservice.getAll(search).then(data => {
        commit('loadNetworks', data);
      });
    },
    resetNetworks: function ({ dispatch }) {
      //commit('loaded', false);
      dispatch('loadNetworks');
    },
    loadTrendingNetworks: function ({ commit }, payload) {
      var search;
      if (payload && 'search' in payload) {
        search = payload.search;
      }

      return networkservice.getTrending(search).then(data => {
        commit('loadTrendingNetworks', data);
      });
    },
    resetTrendingNetworks: function ({ dispatch }) {
      dispatch('loadTrendingNetworks');
    },
    toggleFavStatus: function ({ commit }, slug) {
      return networkservice.toggleLike(slug).then(data => {
        if (data == 1) {
          commit('updateLikeForSlug', { slug, is_liked: false });
        } else {
          commit('updateLikeForSlug', { slug, is_liked: true });
        }
      });
    },
    setCurrentNetwork: function ({ commit }, data) {
      commit('currentNetwork', data);
    },
    loadUserData: function ({ commit }) {
      return networkservice.getUserData().then(data => {
        if (data) {
          commit('setUserData', data);
        }
      }).catch(error => {
        console.error('Failed to load user data:', error);
      });
    },
  },
};
